import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbDropdownModule} from '../dropdown/dropdown.module';

import {CloMobileCard, CloTableRow, CloTable, CloTabletCard} from './table';
export {CloTable, CloTableRow, CloTabletCard, CloMobileCard} from './table';

import {CloTableBlock, CloExportOption, CloFilters, CloFilterGroup, CloFilterOption} from './table-block';
import {CloFilterTableService} from './clo-filter-table.service';
import {NgbTypeaheadModule} from '../typeahead/typeahead.module';
import {SharedModule} from '../util/shared.module';
export {CloTableBlock, CloExportOption, CloFilters, CloFilterGroup, CloFilterOption} from './table-block';

@NgModule({
  declarations: [CloTable, CloTableRow, CloTabletCard, CloMobileCard,
                CloExportOption, CloTableBlock, CloFilters, CloFilterGroup, CloFilterOption],
  exports: [CloTable, CloTableRow, CloTabletCard, CloMobileCard,
            CloExportOption, CloTableBlock, CloFilters, CloFilterGroup, CloFilterOption],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgbDropdownModule, NgbTypeaheadModule, SharedModule],
  entryComponents: [CloTable, CloTableBlock],
  providers: [CloFilterTableService]
})
export class CloTableModule {
}
